import { render, staticRenderFns } from "./customerExclude.vue?vue&type=template&id=57d3ddf3&scoped=true&"
import script from "./customerExclude.vue?vue&type=script&lang=js&"
export * from "./customerExclude.vue?vue&type=script&lang=js&"
import style0 from "./customerExclude.vue?vue&type=style&index=0&id=57d3ddf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3ddf3",
  null
  
)

export default component.exports